import styled from '@emotion/styled';

export const VariantsWrapper = styled.div`
  padding: 10px 0;
  ${({ theme }) => theme.variants.wrapper};
`;

export const VariantsInner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const OptionBlock = styled.div`
  margin-top: 10px;

  &:first-of-type {
    margin-top: 0;
  }

  ${({ theme }) => theme.variants.option};
`;
